import React, { useState, useRef } from "react";


  const MenuViewBroadcast = (props) => {

  const {activeTab, setActiveTab} = props;

  return (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                onClick={() => setActiveTab('contas')}
                aria-pressed={activeTab === 'contas'}
                style={{
                  padding: '8px 14px',
                  borderRadius: 10,
                  border: activeTab === 'contas' ? 'none' : '1px solid rgba(81,161,151,0.25)',
                  background: activeTab === 'contas' ? '#51a197' : 'transparent',
                  color: activeTab === 'contas' ? '#fff' : '#51a197',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: activeTab === 'contas' ? '0 6px 20px rgba(81,161,151,0.18)' : 'none'
                }}
              >
                Contas Associadas
              </button>

              <button
                onClick={() => setActiveTab('leads')}
                aria-pressed={activeTab === 'leads'}
                style={{
                  padding: '8px 14px',
                  borderRadius: 10,
                  border: activeTab === 'leads' ? 'none' : '1px solid rgba(81,161,151,0.25)',
                  background: activeTab === 'leads' ? '#51a197' : 'transparent',
                  color: activeTab === 'leads' ? '#fff' : '#51a197',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: activeTab === 'leads' ? '0 6px 20px rgba(81,161,151,0.18)' : 'none'
                }}
              >
                Leads
              </button>

              <button
                onClick={() => setActiveTab('operacoes')}
                aria-pressed={activeTab === 'operacoes'}
                style={{
                  padding: '8px 14px',
                  borderRadius: 10,
                  border: activeTab === 'operacoes' ? 'none' : '1px solid rgba(81,161,151,0.25)',
                  background: activeTab === 'operacoes' ? '#51a197' : 'transparent',
                  color: activeTab === 'operacoes' ? '#fff' : '#51a197',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: activeTab === 'operacoes' ? '0 6px 20px rgba(81,161,151,0.18)' : 'none'
                }}
              >
                Operações
              </button>
            </div>

          
  );
};

export default MenuViewBroadcast;